(function () {
  var config = window.amuminOrderContext || {};
  var storageKey = "amumin-order-context-v1";
  var firstTouchKey = storageKey + ":first-touch";
  var syncKey = storageKey + ":last-sync";
  var sensitiveParams = [
    "email",
    "e-mail",
    "phone",
    "tel",
    "name",
    "first_name",
    "last_name",
    "address",
    "street",
    "postcode",
    "zip",
    "token",
    "key",
    "customer",
    "password",
  ];

  function readJson(key) {
    try {
      return JSON.parse(window.localStorage.getItem(key) || "null");
    } catch (error) {
      return null;
    }
  }

  function writeJson(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      /* localStorage can be unavailable in strict privacy modes. */
    }
  }

  function truncate(value, maxLength) {
    if (value === undefined || value === null) return "";
    var text = String(value);
    return text.length > maxLength ? text.slice(0, maxLength) : text;
  }

  function cleanUrl(value, includeOrigin) {
    if (!value) return "";

    try {
      var url = new URL(value, window.location.origin);

      sensitiveParams.forEach(function (param) {
        url.searchParams.delete(param);
      });

      var cleaned = url.pathname + url.search;
      return includeOrigin ? url.origin + cleaned : cleaned;
    } catch (error) {
      return truncate(value, 240);
    }
  }

  function getExternalReferrer() {
    if (!document.referrer) return "";

    try {
      var referrer = new URL(document.referrer);
      if (referrer.origin === window.location.origin) return "";
      return cleanUrl(referrer.href, true);
    } catch (error) {
      return "";
    }
  }

  function getFirstTouch() {
    var existing = readJson(firstTouchKey);
    if (existing && existing.path) {
      return existing;
    }

    var firstTouch = {
      path: cleanUrl(window.location.href, false),
      referrer: getExternalReferrer(),
      captured_at: new Date().toISOString(),
    };

    writeJson(firstTouchKey, firstTouch);
    return firstTouch;
  }

  function getTimeZone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    } catch (error) {
      return "";
    }
  }

  function buildAttributes() {
    var firstTouch = getFirstTouch();
    var shopify = window.Shopify || {};
    var currency = shopify.currency && shopify.currency.active ? shopify.currency.active : "";
    var browserLanguages = Array.isArray(navigator.languages)
      ? navigator.languages.slice(0, 5).join(",")
      : "";

    return {
      amumin_context_v__: truncate(config.version || "2026-05-04", 32),
      amumin_lang__: truncate(config.language || shopify.locale || document.documentElement.lang || "", 32),
      amumin_country__: truncate(config.country || shopify.country || "", 32),
      amumin_country_name__: truncate(config.countryName || "", 80),
      amumin_market__: truncate(config.market || "", 80),
      amumin_currency__: truncate(currency, 16),
      amumin_browser_lang__: truncate(navigator.language || "", 32),
      amumin_browser_langs__: truncate(browserLanguages, 160),
      amumin_timezone__: truncate(getTimeZone(), 80),
      amumin_entry_path__: truncate(firstTouch.path, 240),
      amumin_referrer__: truncate(firstTouch.referrer, 240),
      amumin_last_path__: truncate(cleanUrl(window.location.href, false), 240),
    };
  }

  function getCartUpdateUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";

    return root.replace(/\/?$/, "/") + "cart/update.js";
  }

  function readLastSync() {
    try {
      return JSON.parse(window.sessionStorage.getItem(syncKey) || "null");
    } catch (error) {
      return null;
    }
  }

  function writeLastSync(payload) {
    try {
      window.sessionStorage.setItem(
        syncKey,
        JSON.stringify({ payload: payload, at: Date.now() })
      );
    } catch (error) {
      /* sessionStorage can be unavailable in strict privacy modes. */
    }
  }

  function syncContext(options) {
    options = options || {};

    var attributes = buildAttributes();
    var payload = JSON.stringify(attributes);
    var lastSync = readLastSync();
    var recentlySynced =
      lastSync &&
      lastSync.payload === payload &&
      Date.now() - Number(lastSync.at || 0) < 5 * 60 * 1000;

    if (!options.force && recentlySynced) {
      return Promise.resolve();
    }

    return fetch(getCartUpdateUrl(), {
      method: "POST",
      credentials: "same-origin",
      keepalive: Boolean(options.keepalive),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ attributes: attributes }),
    })
      .then(function (response) {
        if (response.ok) {
          writeLastSync(payload);
        }
      })
      .catch(function () {
        /* Tracking context must never block shopping or checkout. */
      });
  }

  function isCheckoutTrigger(element) {
    if (!element || !element.closest) return false;

    return Boolean(
      element.closest('a[href*="/checkout"]') ||
        element.closest('button[name="checkout"]') ||
        element.closest('input[name="checkout"]')
    );
  }

  syncContext();

  document.addEventListener(
    "pointerdown",
    function (event) {
      if (isCheckoutTrigger(event.target)) {
        syncContext({ force: true, keepalive: true });
      }
    },
    true
  );

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (form && form.matches && form.matches('form[action*="/cart"]')) {
        syncContext({ force: true, keepalive: true });
      }
    },
    true
  );
})();
